import { useMediaQuery } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../Button";
import MemberInfoModalButton from "../MemberInfoModalButton";
import {
    navigateBackToSearch,
    persistReturnToSearchUrl,
} from "../../utils/memberNavigation";
import styles from "./styles.module.scss";

export type MemberDashboardPage = "trades" | "formation" | "payouts";

interface Props {
    userId: string;
    currentPage: MemberDashboardPage;
    canEditMemberProfile: boolean;
    onEditProfile: () => void;
}

const MemberDashboardHeaderActions: FC<Props> = ({
    userId,
    currentPage,
    canEditMemberProfile,
    onEditProfile,
}) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width: 1050px)");
    const buttonSize = isMobile ? "medium" : "newSmall";

    const labels = {
        trades: isMobile ? "Performances" : "Voir les trades",
        formation: isMobile ? "Progression" : "Voir le suivi",
        payouts: isMobile ? "Payouts" : "Voir les payouts",
        edit: isMobile ? "Éditer" : "Éditer le profil",
        back: "Retourner à la recherche",
    };

    const goTo = (path: string) => {
        persistReturnToSearchUrl();
        navigate(path);
    };

    const backButton = (
        <Button
            size={buttonSize}
            variant="secondary"
            className={isMobile ? styles.backButton : styles.desktopBackButton}
            onClick={() => navigateBackToSearch(navigate)}
        >
            {labels.back}
        </Button>
    );

    return (
        <div className={styles.wrapper}>
            {isMobile && <div className={styles.backRow}>{backButton}</div>}
            <div className={styles.actionsGrid}>
                {currentPage !== "trades" && (
                    <Button
                        size={buttonSize}
                        variant="primary_outlined"
                        className={styles.actionButton}
                        onClick={() =>
                            goTo(`/trades?userId=${encodeURIComponent(userId)}`)
                        }
                    >
                        {labels.trades}
                    </Button>
                )}
                {currentPage !== "formation" && (
                    <Button
                        size={buttonSize}
                        variant="primary_outlined"
                        className={styles.actionButton}
                        onClick={() =>
                            goTo(
                                `/formation?userId=${encodeURIComponent(userId)}`,
                            )
                        }
                    >
                        {labels.formation}
                    </Button>
                )}
                {currentPage !== "payouts" && (
                    <Button
                        size={buttonSize}
                        variant="primary_outlined"
                        className={styles.actionButton}
                        onClick={() =>
                            goTo(`/payouts?userId=${encodeURIComponent(userId)}`)
                        }
                    >
                        {labels.payouts}
                    </Button>
                )}
                <MemberInfoModalButton
                    userId={userId}
                    size={buttonSize}
                    className={styles.actionButton}
                    label={isMobile ? "Infos" : "Voir les infos"}
                />
                {canEditMemberProfile && (
                    <Button
                        size={buttonSize}
                        variant="primary_outlined"
                        className={styles.actionButton}
                        onClick={() => {
                            void onEditProfile();
                        }}
                    >
                        {labels.edit}
                    </Button>
                )}
                {!isMobile && backButton}
            </div>
        </div>
    );
};

export default MemberDashboardHeaderActions;
